import { useSelector } from 'react-redux';
import { selectOfferType } from 'shared/selectors/jsonQuery';
import { FOfferType } from '../../../../../../../packages/JsonQuery';
import { BannerInFilter } from 'shared/components/BannerInFilter';
import { PParams } from '@cian/postview-analytics-utils';
import { TAdfoxContextData } from 'shared/types/adfox';
import { AdfoxBannerContainer } from '../../../../../../../packages/Adfox';
import { selectBannerPuids } from 'shared/selectors/adfox';
import { useMemo } from 'react';

const POST_VIEW_ANALYTICS_DATA: TAdfoxContextData['postViewAnalyticsData'] = {
  place: 'additional_filters',
  place__DEPRECATED: 'offersSerp',
  name__DEPRECATED: 'Listing_filter_more',
};
const P_PARAMS: PParams = { p1: 'crzye', p2: 'fmsa' };
const SIZE: TAdfoxContextData['size'] = { width: '100%', height: 100 };

export const PikBannerInFiltersContainer: React.FC = () => {
  const bannerPuids = useSelector(selectBannerPuids);
  const offerType = useSelector(selectOfferType);

  const params = useMemo(() => ({ ...bannerPuids, ...P_PARAMS }), [bannerPuids]);

  if (offerType !== FOfferType.FlatNew) {
    return null;
  }

  return (
    <BannerInFilter>
      <AdfoxBannerContainer params={params} size={SIZE} postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA} />
    </BannerInFilter>
  );
};
